import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import api from './api';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import Card from 'react-bootstrap/Card';
import Spinner from 'react-bootstrap/Spinner';

function Login({ setToken, setUserRole }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Sunucu ısındırma: Render ücretsiz sunucusu uykudaysa, kullanıcı formu
  // doldururken arka planda uyansın (girişte 30-60 sn bekleme yaşanmasın).
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/health`).catch(() => {});
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await api.post('/giris', {
        kullanici_adi: username,
        sifre: password,
      });
      const data = response.data;
      
      // Bellekteki token değerini hemen atayın, api.js interceptor'da kullanılsın
      window._accessToken = data.access_token;
      
      localStorage.setItem('accessToken', data.access_token);
      // refreshToken artık httpOnly cookie'den gidiyor, localStorage'a gerek yok ama eski uyum için bırakılabilir.
      if (data.refresh_token) {
          localStorage.setItem('refreshToken', data.refresh_token);
      }
      localStorage.setItem('userRole', data.kullanici.rol);
      localStorage.setItem('sifreDegistirildi', data.kullanici.sifre_degistirildi !== false ? 'true' : 'false');
      localStorage.setItem('isDemo', data.kullanici.is_demo ? 'true' : 'false');
      localStorage.setItem('kullaniciAdi', data.kullanici.kullanici_adi || '');
      
      setToken(data.access_token);
      setUserRole(data.kullanici.rol);
      // Giriş başarılı — dashboard'a yönlendir (React Router ile)
      navigate('/', { replace: true });
    } catch (err) {
      setError(err.response?.data?.mesaj || 'Giriş sırasında bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ position: 'relative', height: '100vh' }}>
      <div className="aurora-background" />
      <div className="d-flex align-items-center justify-content-center h-100" style={{position: 'relative', zIndex: 1}}>
        
        <Card className="glass-card text-white" style={{ width: '24rem' }}>
          <Card.Body>
            <h2 className="text-center mb-4">Giriş Yap</h2>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="formBasicUsername">
                <Form.Label>Kullanıcı Adı</Form.Label>
                <Form.Control 
                  type="text" 
                  placeholder="Kullanıcı adınızı girin" 
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required 
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Şifre</Form.Label>
                <Form.Control 
                  type="password" 
                  placeholder="Şifreniz" 
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required 
                />
              </Form.Group>

              <Button variant="primary" type="submit" className="w-100" disabled={loading}>
                {loading ? (
                  <>
                    <Spinner as="span" animation="border" size="sm" className="me-2" />
                    Giriş yapılıyor…
                  </>
                ) : 'Giriş Yap'}
              </Button>

              <div className="text-center mt-3">
                <Link to="/sifremi-unuttum" style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>
                  Şifremi unuttum
                </Link>
              </div>

              {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
            </Form>
          </Card.Body>
        </Card>

      </div>
    </div>
  );
}

export default Login;